import axios from 'axios'
import store from '../store'
// import { toast } from './toast'
import { MessageBox } from 'mint-ui'
// import { getToken } from './auth'
import { addLogInfo } from '@/api/user'
import { toast } from './toast'

console.log(process,"process.env.BASE_URL")
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_URL, // api 的 base_url
  timeout: 15000 // 请求超时的时间
})

// 日志信息
let logData = {
  url: '',
  data: ''
}
// 当前接口url
let currentUrl = ''

// 需记录日志的接口列表
// 修改个人信息 ordering_system_mobile/userinfo/updateuserInformation
// 地址修改 ordering_system_mobile/useraddress/saveUserAddress
let logApiList = [
  process.env.BASE_URL + 'ordering_system_mobile/userinfo/updateuserInformation',
  process.env.BASE_URL + 'ordering_system_mobile/useraddress/saveUserAddress'
]

// axios 请求拦截器
service.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json'
  // if (store.getters.token) {
  //   config.data['token'] = getToken() // 让每个请求携带token
  // }
  // console.log(config)
  if (store.state.user.token) {
    config.data = {data: JSON.stringify({...config.data, token: store.state.user.token})}
  }
  logData.url = config.baseURL + '' + config.url
  logData.data = config.data
  currentUrl = config.baseURL + '' + config.url
  // console.log(logData)
  // console.log(config)
  return config
}, error => {
  // 错误处理
  // console.log(error) // for debug
  Promise.reject(error)
})

// axios 响应拦截器
service.interceptors.response.use(response => {
  // （假设）code为非0是抛出错误
  const res = response.data
  // console.log(res)
  if (res.erroyCode !== 200) {
    // console.log(res.erroyCode)
    // toast(res.erroyMsg)
    // 以下是假设：
    // -10001 : token已过期 ;
    // -10000 : 无效token;
    console.log(res)
    if (res.erroyCode === -20000) {
      // console.log('你已被登出，可以取消继续留在该页面，或者重新登录')
      toast('您的登录信息已过期，请重新登录');
      store.dispatch('LoginOut').then(() => {
        // location.reload() // 为了重新实例化vue-router对象 避免bug
      });
      
      // MessageBox({
      //   title: '提示',
      //   message: '您的登录信息已过期，请重新登录',
      //   showCancelButton: false
      // }).then(action => {
      //   // console.log(action)
      // })
    } else {
      // toast('暂无数据')
      return response.data
    }
    // return Promise.reject(new Error('error'))
  } else {
    // console.log(logApiList)
    // console.log(currentUrl)
    if (logApiList.indexOf(currentUrl) !== -1) { addLogInfo(logData) }
    return response.data
  }
}, error => {
  console.log('err' + error) // fordebug
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js